//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Rule.js";
import "../no/NXObject.js";
let d=[[[0,"NodeIdentifier",0,0]],[[["numPorts","inputPorts"],"GetInputPorts",{},0,0],[["numPorts","outputPorts"],"GetOutputPorts",{},0,0],[["numOutputs","outputNames"],"GetOutputNames",{},0,0],[["portId"],"GetConnectorAtInputPort",{R_:{connector:"Rule.Connector"}},1,0],[["portId"],"GetConnectorAtOutputPort",{R_:{connector:"Rule.Connector"}},1,0],[[],"Destroy",{},0,0]],[]];
SPLM.Rule.Node = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Rule.Node";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;